import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';

export default function configureStoreProd(initialState?: any) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    devTools: false, // Disable Redux DevTools in production
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore theme object with MUI breakpoints.up function
          ignoredActions: ['SAVE_THEME_SUCCESS'],
          ignoredActionPaths: ['theme'],
          ignoredPaths: ['theme'],
        },
        immutableCheck: {
          // Ignore theme object — MUI mutates it internally (e.g. lazy breakpoint resolution)
          ignoredPaths: ['theme', 'rd1s'],
        },
      }),
  });
}
